import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

const processEnv = (import.meta as unknown as { env: NodeJS.ProcessEnv }).env;

export const env = createEnv({
  skipValidation: processEnv.SKIP_ENV_VALIDATION === "1",
  clientPrefix: "VITE_",
  client: {
    VITE_GIT_COMMIT: z.string().optional().default("dev"),
    VITE_SERVERSIDE_HOST: z.string(),
    VITE_CLIENTSIDE_HOST: z.string().url().default("http://localhost:5173"),
    VITE_COLLAB_HOST: z.string().url().default("ws://localhost:9933/collab"),
    VITE_RECAPTCHA_SITE_KEY: z.string(),
    VITE_POSTHOG_KEY: z.string(),
    VITE_POSTHOG_HOST: z.string(),
    VITE_NODE_ENV: z.enum(["development", "production"]),
    VITE_UMO_REMOTE_URL: z.string().optional(),
    VITE_MOBILE_REMOTE_URL: z.string().optional(),
    VITE_CDN_PATH: z.string().url().default("http://localhost:8787/cdn"),
  },
  runtimeEnv: processEnv,
});
